import classNames from "classnames";

import styles from "./product-grid.module.scss";

type Props = {
  color1: string;
  color2: string;
  changeHeaderLayout?: boolean;
  defaultDesktopBackground?: boolean;
  hasBannerHeader?: boolean;
  type: "mobile" | "desktop";
};

export default function ProductGridCustomBackground({
  color1,
  color2,
  changeHeaderLayout,
  defaultDesktopBackground = false,
  hasBannerHeader,
  type,
}: Props) {
  if (changeHeaderLayout && type === "desktop") {
    return null;
  }

  if (defaultDesktopBackground && !hasBannerHeader) {
    return (
      <div className={classNames(styles.backgroundContainer, styles.defaultDesktopBackground, styles.desktopOnly)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 623 861" fill="none" aria-hidden="true">
          <g clipPath="url(#clip0_4238_496378)">
            <g opacity="0.18" filter="url(#filter0_f_4238_496378)">
              <path
                d="M-131.116 -12.5997C-207.538 -81.7202 -332.977 -11.5751 -383.464 73.779C-445.238 178.216 -371.005 248.023 -298.871 245.696C-152.525 240.977 -148.871 408.631 0.00849672 436.514C394.491 510.396 328.71 173.228 243.585 108.775C10.2723 -67.8798 55.0992 181.351 -30.0176 146.826C-102.986 117.229 -54.6934 56.5209 -131.116 -12.5997Z"
                fill={color2}
              />
            </g>
            <g opacity="0.16" filter="url(#filter1_f_4238_496378)">
              <path
                d="M166.179 548.732C271.012 599.777 385.242 484.024 413.221 375.355C447.456 242.39 344.787 189.91 267.123 215.163C109.56 266.398 52.7706 85.3411 -117.817 101.94C-569.821 145.923 -392.107 491.637 -279.287 534.868C29.9331 653.354 -97.3033 396.61 6.0792 407.317C94.7058 416.495 61.3471 497.688 166.179 548.732Z"
                fill={color1}
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_4238_496378"
              x="-506.494"
              y="-140.633"
              width="914.728"
              height="687.672"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_4238_496378" />
            </filter>
            <filter
              id="filter1_f_4238_496378"
              x="-510.404"
              y="0.859375"
              width="1030.4"
              height="665.32"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_4238_496378" />
            </filter>
            <clipPath id="clip0_4238_496378">
              <rect width="623" height="861" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    );
  }

  return (
    <div className={styles.backgroundContainer}>
      {changeHeaderLayout ? (
        <svg
          className={classNames(styles.svgBackground, styles.mobileOnly)}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 375 200"
          fill="none"
          aria-hidden="true"
        >
          <g opacity="0.18" filter="url(#filter0_f_7572_30851)">
            <path
              d="M-244.966 -346.878C-340.54 -393.415 -444.682 -287.884 -470.19 -188.812C-501.401 -67.5899 -407.8 -19.7446 -336.995 -42.768C-193.347 -89.4775 -141.573 75.5891 13.9497 60.4559C426.035 20.3579 264.016 -294.825 161.159 -334.238C-120.752 -442.26 -4.75266 -208.191 -99.005 -217.952C-179.805 -226.319 -149.392 -300.341 -244.966 -346.878Z"
              fill={color1}
            />
          </g>
          <g opacity="0.18" filter="url(#filter1_f_7572_30851)">
            <path
              d="M197.079 -257.304C96.5911 -222.63 97.5727 -74.3687 149.59 13.7227C213.238 121.509 313.256 89.1549 347.042 22.8082C415.588 -111.795 568.918 -31.685 668.188 -152.357C931.223 -472.099 593.79 -580.402 493.19 -535.54C217.465 -412.582 465.002 -329.094 391.453 -269.35C328.403 -218.133 297.566 -291.979 197.079 -257.304Z"
              fill={color2}
            />
          </g>
          <defs>
            <filter
              id="filter0_f_7572_30851"
              x="-576.37"
              y="-462.781"
              width="957.067"
              height="624.219"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_7572_30851" />
            </filter>
            <filter
              id="filter1_f_7572_30851"
              x="14.7922"
              y="-645.219"
              width="851.612"
              height="829.07"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_7572_30851" />
            </filter>
          </defs>
        </svg>
      ) : (
        <svg
          className={classNames(
            styles.svgBackground,
            styles.mobileOnly,
            hasBannerHeader && type === "desktop" ? styles.hide : undefined
          )}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 375 240"
          aria-hidden="true"
        >
          <g opacity=".16" filter="url(#a)">
            <path
              d="M-93.349-130.764c-59.979-29.205-125.334 37.022-141.342 99.196-19.587 76.075 39.154 106.1 83.588 91.652 90.148-29.313 122.64 74.276 220.24 64.779 258.609-25.164 156.932-222.96 92.383-247.694C-15.397-190.622 57.4-43.729-1.75-49.855c-50.706-5.25-31.62-51.704-91.599-80.909Z"
              fill={color1}
            />
          </g>
          <g opacity=".18" filter="url(#b)">
            <path
              d="M184.059-74.554c-63.062 21.76-62.446 114.804-29.802 170.087 39.943 67.643 102.71 47.338 123.914 5.701C321.187 16.763 417.411 67.037 479.71-8.693c165.07-200.657-46.69-268.624-109.822-240.471C196.853-172 352.197-119.606 306.041-82.113c-39.568 32.142-58.92-14.201-121.982 7.56Z"
              fill={color2}
            />
          </g>
          <defs>
            <filter
              id="a"
              x="-338.569"
              y="-240.742"
              width="675.106"
              height="466.227"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_1555_321020" />
            </filter>
            <filter
              id="b"
              x="32.419"
              y="-355.234"
              width="608.928"
              height="594.781"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_1555_321020" />
            </filter>
          </defs>
        </svg>
      )}
      {changeHeaderLayout && !hasBannerHeader && (
        <svg
          className={styles.desktopOnly}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1366 377"
          fill="none"
          aria-hidden="true"
        >
          <g opacity="0.18" filter="url(#filter0_f_7572_30270)">
            <path
              d="M210.375 -391.41C79.8733 -454.953 -62.3275 -310.857 -97.1573 -175.58C-139.774 -10.057 -11.9667 55.2732 84.7138 23.8359C280.857 -39.9434 351.552 185.446 563.91 164.783C1126.59 110.031 905.362 -320.334 764.917 -374.15C379.982 -521.65 538.373 -202.04 409.676 -215.368C299.349 -226.793 340.876 -327.866 210.375 -391.41Z"
              fill={color1}
            />
          </g>
          <g opacity="0.18" filter="url(#filter1_f_7572_30270)">
            <path
              d="M804.239 -302.587C659.45 -292.366 608.349 -96.4752 645.824 38.0936C691.678 202.749 835.027 195.423 903.037 119.857C1041.01 -33.4493 1214.93 126.396 1388.51 2.3223C1848.43 -326.434 1441.65 -588.527 1293.12 -564.911C886.004 -500.181 1182.98 -302.587 1064.86 -249.781C963.602 -204.512 949.028 -312.807 804.239 -302.587Z"
              fill={color2}
            />
          </g>
          <defs>
            <filter
              id="filter0_f_7572_30270"
              x="-205.595"
              y="-513.125"
              width="1233.74"
              height="779.25"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_7572_30270" />
            </filter>
            <filter
              id="filter1_f_7572_30270"
              x="533.98"
              y="-666.391"
              width="1167.29"
              height="937.664"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_7572_30270" />
            </filter>
          </defs>
        </svg>
      )}
    </div>
  );
}
